import { useBlockerStore } from './blocker';
import { useConfirmStore } from './confirm';
import { useSnackbarStore } from './snackbar';

// expose some global proxy wrappers to avoid consuming applications needing to get direct references to cove's pinia stores.
// this also keeps things flexible and allows us to swap out storage mechanisms in the future with minor refactoring as the underlying
// technology is hidden.
//
// NOTE: the validation / error store helpers are located in the validation file. since there are so many and they are so closely linked
// with validations it made sense to nest/namespace them there.
//
export const helpers = {
  block ({ delay = 333 } = {}) {
    const blockerStore = useBlockerStore();
    blockerStore.$patch({ visible: true, delay });
  },

  blockNow () {
    const blockerStore = useBlockerStore();
    blockerStore.$patch({ visible: true, delay: 0 });
  },

  unblock () {
    const blockerStore = useBlockerStore();
    blockerStore.$patch({ visible: false });
  },

  notify ({ color, message }) {
    const snackbarStore = useSnackbarStore();
    snackbarStore.$patch({ color, message, visible: true });
  },

  confirm ({ message, subtitleKey = null, typingPromptKey = null, width = 450 }) {
    const confirmStore = useConfirmStore();
    return confirmStore.show({ message, subtitleKey, typingPromptKey, width });
  }
};